import { render } from "./ShowLama.vue?vue&type=template&id=5aa63981"
import script from "./ShowLama.vue?vue&type=script&lang=js"
export * from "./ShowLama.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__